import { EmailMessage } from '../../hooks/useEmailAPI';

interface EmailDetailProps {
  email: EmailMessage | null;
}

const EmailDetail = ({ email }: EmailDetailProps) => {
  if (!email) {
    return (
      <div className="p-8 text-center text-[#8a7266] bg-white border rounded-lg h-full flex flex-col items-center justify-center">
        <div className="text-[#ff8c42] mb-2">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto">
            <path d="M19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4H9L11 6H19C20.1046 6 21 6.89543 21 8V20C21 21.1046 20.1046 22 19 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <p>Select an email to view its contents</p>
      </div>
    );
  }
  
  return (
    <div className="p-6 bg-white border rounded-lg">
      <div className="mb-6 pb-4 border-b">
        <h2 className="text-xl font-semibold text-[#694e42] mb-2">{email.subject}</h2>
        <div className="flex justify-between items-center">
          <div>
            <div className="font-medium text-[#694e42]">From: {email.from}</div>
            {email.to && <div className="text-sm text-[#8a7266]">To: {email.to}</div>}
          </div>
          <div className="text-sm text-[#8a7266]">
            {new Date(email.receivedAt).toLocaleString()}
          </div>
        </div>
      </div>
      
      <div className="email-body text-[#694e42]">
        {email.body ? (
          <div>{email.body}</div>
        ) : (
          <div className="text-[#8a7266] italic">No content available</div>
        )}
      </div>
    </div>
  );
};

export default EmailDetail;